import React from 'react'
import deburr from 'lodash/deburr'
import Autosuggest from 'react-autosuggest'
import match from 'autosuggest-highlight/match'
import parse from 'autosuggest-highlight/parse'
import {
  Typography,
  TextField,
  Paper,
  MenuItem,
  makeStyles
} from '@material-ui/core'

const suggestions = [
  { label: 'Aaren', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Aarika', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Baab', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Barbara', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Carha', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Casey', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Daisy', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Dael', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Easter', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Eba', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Fae', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Fan', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Gabey', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Gabi', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Hadria', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Helen', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Ian', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Ivey', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Jan', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Jenny', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Kim', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Kimberly', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Lany', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Liam', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Miguel', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Miguel Lopez', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Nas', date: '2019-08-18', profileID: '7897899-8409294' },
  { label: 'Nerry', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Oprah', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Peter', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Polly', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Qeery', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Quenny', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Ram', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Rustom', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Samantha', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Sheila', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Tabitha', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Tammy', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Uhma', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Victor', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Wally', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Xivey', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Yexel', date: '2018-06-16', profileID: '345355-8409294' },
  { label: 'Ziggy', date: '2018-06-16', profileID: '345355-8409294' }
]

function renderInputComponent(inputProps) {
  const { classes, inputRef = () => {}, ref, ...other } = inputProps

  return (
    <TextField
      variant='outlined'
      fullWidth
      InputProps={{
        inputRef: node => {
          ref(node)
          inputRef(node)
        },
        classes: {
          input: classes.input
        }
      }}
      {...other}
    />
  )
}

function renderSuggestion(suggestion, { query, isHighlighted }) {
  const matches = match(suggestion.label, query)
  const parts = parse(suggestion.label, matches)

  return (
    <MenuItem selected={isHighlighted} component='div'>
      <div>
        {parts.map(part => (
          <span
            key={part.text}
            style={{ fontWeight: part.highlight ? 500 : 400 }}
          >
            {part.text}
          </span>
        ))}
        <Typography variant='body2' color='textSecondary'>
          2018-06-16 | 345355-8409294
        </Typography>
      </div>
    </MenuItem>
  )
}

function getSuggestions(value) {
  const inputValue = deburr(value.trim()).toLowerCase()
  const inputLength = inputValue.length
  let count = 0

  return inputLength === 0
    ? []
    : suggestions.filter(suggestion => {
        const keep =
          count < 5 &&
          suggestion.label.slice(0, inputLength).toLowerCase() === inputValue

        if (keep) {
          count += 1
        }

        return keep
      })
}

function getSuggestionValue(suggestion) {
  return suggestion.label
}

const useStyles = makeStyles(theme => ({
  root: {
    //height: 250,
    flexGrow: 1
  },
  container: {
    position: 'relative'
  },
  suggestionsContainerOpen: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0
  },
  suggestion: {
    display: 'block'
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none'
  },
  divider: {
    height: theme.spacing(2)
  }
}))

const SearchField = () => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [state, setState] = React.useState({
    single: '',
    popper: ''
  })

  const [stateSuggestions, setSuggestions] = React.useState([])

  const handleSuggestionsFetchRequested = ({ value }) => {
    setSuggestions(getSuggestions(value))
  }

  const handleSuggestionsClearRequested = () => {
    setSuggestions([])
  }

  const handleChange = name => (event, { newValue }) => {
    setState({
      ...state,
      [name]: newValue
    })
  }

  const autosuggestProps = {
    renderInputComponent,
    suggestions: stateSuggestions,
    onSuggestionsFetchRequested: handleSuggestionsFetchRequested,
    onSuggestionsClearRequested: handleSuggestionsClearRequested,
    getSuggestionValue,
    renderSuggestion
  }

  return (
    <div className={classes.root}>
      <Autosuggest
        {...autosuggestProps}
        inputProps={{
          classes,
          id: 'react-autosuggest-simple',
          label: 'Search for a Person or Organisation',
          placeholder: 'Input any letter from a-z',
          value: state.single,
          onChange: handleChange('single')
        }}
        theme={{
          container: classes.container,
          suggestionsContainerOpen: classes.suggestionsContainerOpen,
          suggestionsList: classes.suggestionsList,
          suggestion: classes.suggestion
        }}
        renderSuggestionsContainer={options => (
          <Paper {...options.containerProps} square>
            {options.children}
          </Paper>
        )}
      />
    </div>
  )
}

export default SearchField
